import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson7/Answer/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson7/Answer/Issue2";
import styles from "../../ActiveLearningLesson.module.scss";

type Lesson7AnswerProps = {
  materialCode: string;
  lessonNo: number;
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson7Answer = (props: Lesson7AnswerProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(1)}
        />
      </div>
      <div className={styles.section}>
        <Issue2
          materialCode={props.materialCode}
          lessonNo={props.lessonNo}
          issue={props.findIssue && props.findIssue(2)}
        />
      </div>
    </>
  );
};
export default Lesson7Answer;
